import { RefreshTokenResponseDto } from '@dto/user/user.response.dto'
import { IUser } from '@interfaces/user.interface'
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'

export interface IAuth {
  isAuth: boolean
  accessToken: string
  refreshToken: string
  isActive: boolean
  user: IUser | null
  isLoading: boolean
}

const initialState: IAuth = {
  accessToken: '',
  refreshToken: '',
  isActive: true,
  isAuth: false,
  user: null,
  isLoading: false,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state: Draft<IAuth>, { payload }) => {
      state.isAuth = payload.isAuth
      state.isActive = payload.isActive
      state.accessToken = payload.accessToken
      state.refreshToken = payload.refreshToken
      state.user = payload.user
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload.isLoading
    },
    updateTokens: (state: Draft<IAuth>, action: PayloadAction<RefreshTokenResponseDto>) => {
      state.accessToken = action.payload.accessToken
      state.refreshToken = action.payload.refreshToken
    },
  },
})

export const { setUser, setLoading, updateTokens } = authSlice.actions

export default authSlice.reducer
